import { Component, OnInit, Input, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { DashboardService } from '../../dashboard.service';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-dashboard-item-grid',
  templateUrl: './dashboard-item-grid.component.html',
  styleUrls: ['./dashboard-item-grid.component.css']
})

export class DashboardItemGridComponent implements OnInit {

  private height: string;

  @Input() id: string;
  @Input() idCpt: string;
  @Input() title: string;
  @Input() set size(value: {height: number, width: number}) {
    this.render.setStyle(this.gridRef.nativeElement, 'height', `${value.height - 25}px`);
  }
  @ViewChild('gridRef', { static: false }) gridRef: ElementRef;

  constructor(
    private dashboardservice: DashboardService,
    private render: Renderer2
  ) { }

  ngOnInit(): void {}
}


